import _isNil from 'lodash/isNil';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import {z} from 'zod';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import toolError from 'common/src/modules/shared/copilot/utils/toolError';
import {ContentCardScratchpadState} from '../../scratchpad/contentCardScratchpad.types';
import validateAgentScratchpad from '../../utils/general/validateAgentScratchpad';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {contentSetsApi} from 'common/src/modules/contentSets/contentSets.api';

const inputSchema = z.object({
  contentSetId: z
    .number()
    .optional()
    .describe('The content set ID, when removing the content set, leave this field empty'),
});

async function execute({
  input: {contentSetId},
  toolUtils: {agentScratchpad},
}: ToolExecuteParams<typeof inputSchema, ContentCardScratchpadState>): Promise<ToolResult> {
  const validatedScratchpad = validateAgentScratchpad<ContentCardScratchpadState>(
    agentScratchpad,
    NodeType.CONTENT_FEED,
  );

  if (_isNil(contentSetId)) {
    validatedScratchpad.card.contentSetId = undefined;
    validatedScratchpad.card.contentSet = undefined;

    return toolResult('Content set removed');
  }

  const availableSets = await contentSetsApi.getContentSets(validatedScratchpad.card.contentFeedId);

  if (!availableSets.some((s) => s.id === contentSetId)) {
    return toolError(
      `Content set with ID ${contentSetId} is not available. Available content sets: ${availableSets.map((s) => `${s.id}: ${s.name}`).join(', ')}`,
    );
  }

  validatedScratchpad.card.contentSetId = contentSetId;

  return toolResult(`Content set set to ${contentSetId}`);
}

export default function setContentSetTool() {
  return tool({
    name: V2CardAgentToolName.SetContentSet,
    displayName: 'Setting content set',
    description: 'Set the content set for the card.',
    inputSchema,
    execute,
  });
}
